<div>
  <div
    class="ficha-cadastro-veiculo-proprio-lista"
    [ngClass]="{'ficha-cadastro-veiculo-proprio-lista_last': i === (veiculos.length -1) }"
    *ngFor="let veiculo of veiculos; let i = index">
    <app-ficha-cadastro-veiculo-proprio-card
      *ngIf="veiculo.saved && !veiculo.isEdit"
      [index]="i"
      [veiculos]="veiculos"
      (remover)="removeVeiculo(i)"
      (editar)="editarVeiculo(i)"
      [veiculo]="veiculo">
    </app-ficha-cadastro-veiculo-proprio-card>

    <app-ficha-cadastro-veiculo-proprio-add
      *ngIf="!veiculo.saved || veiculo.isEdit"
      [index]="i"
      [veiculo]="veiculo"
      [veiculos]="veiculos"
      (salvar)="saveVeiculo($event, i)"
      (adicionar)="addVeiculo()"
      (remover)="cancelVeiculo(i)">
    </app-ficha-cadastro-veiculo-proprio-add>
  </div>

  <div
    *ngIf="showAddVeiculo"
    class="row marginT30 form-group tab-buttons ficha-cadastro-veiculo-proprio-lista_btn">
    <a
      (click)="addVeiculo()"
      class="bt-back btn btn-border-orange pull-left">
      <i class="fa fa-plus mrBt"></i> Adicionar Veículo</a>
  </div>
</div>
